import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  useEffect(() => {
    // Prevent script from being added multiple times
    if (!document.getElementById('tawk-script')) {
      const script = document.createElement('script');
      script.id = 'tawk-script';
      script.src = 'https://embed.tawk.to/687db4a23606072bf84a6566/1j0lgj6tc';
      script.async = true;
      script.charset = 'UTF-8';
      script.setAttribute('crossorigin', '*');
      document.body.appendChild(script);
    }

    // Optional customization after Tawk is loaded
const interval = setInterval(() => {
  const tawkBubble = document.getElementById('tawk-bubble-container');

  if (tawkBubble) {
    // Disable pointer events so it doesn't intercept clicks
    tawkBubble.style.pointerEvents = 'none';

    // Add margin-top using inline style
    tawkBubble.style.marginTop = '50px'; // adjust value as needed

    // Alternatively, add a CSS class
    // tawkBubble.classList.add('mt-12'); // if using Tailwind CSS

    clearInterval(interval); // Stop checking once it's found
  }
}, 500); // check every 500ms

    return () => clearInterval(interval); // cleanup on unmount
  }, []);

  return (
    <footer className="bg-gray-100 text-center py-4 shadow-inner mt-24">
      <p className="text-sm text-gray-600">
        © {new Date().getFullYear()} Powered by <span className="font-semibold">Pentabooks</span>
      </p>
      <div className="mt-2 text-xs text-gray-500">
        <Link to="/privacy-policy" className="underline hover:text-gray-700">
          Privacy Policy
        </Link>
        <span className="mx-2">•</span>
        <Link to="/terms-and-conditions" className="underline hover:text-gray-700">
          Terms &amp; Conditions
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
